import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { Input, InputGroup } from "../../Catalyst/input";

// Header "Search ⌘K" field shared by the organization hierarchy pages. Submitting
// hands the query to the global search page; ⌘K / Ctrl+K focuses the field.
const GlobalSearchField = ({ className }: { className?: string }) => {
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement>(null);
  const [term, setTerm] = useState("");

  useEffect(() => {
    const handleShortcut = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handleShortcut);
    return () => window.removeEventListener("keydown", handleShortcut);
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const query = term.trim();
    navigate(query ? `/search?q=${encodeURIComponent(query)}` : "/search");
  };

  return (
    <form onSubmit={handleSubmit} role="search" className={className}>
      <InputGroup>
        <MagnifyingGlassIcon />
        <Input
          ref={inputRef}
          name="globalSearch"
          value={term}
          onChange={(event) => setTerm(event.target.value)}
          placeholder="Search ⌘K"
          aria-label="Search users and organizations"
        />
      </InputGroup>
    </form>
  );
};

export default GlobalSearchField;
